import { Formik, FormikHelpers, FormikProps } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col } from 'react-bootstrap';
import Store from '../../store';
import { emptyRegions } from '../../store/initial';
import { InjectedProps } from '../../types';
import { Regions } from '../../types/Regions';
import ControlButtonSave from '../misc/ControlButtonSave';
import RegionsForm, { IRegions } from './RegionsForm';

interface RegionsNewProps {
    handleClose: (regions: Regions) => any;
    store?: Store;
}

@inject('store')
@observer
export class RegionsNew extends React.Component<RegionsNewProps> {
    public get injected() {
        return this.props as InjectedProps;
    }

    public initialValues = () => ({ ...emptyRegions });

    public render() {
        return (
            <>
                <Col>
                    <Formik
                        initialValues={this.initialValues()}
                        enableReinitialize
                        onSubmit={this.handleSubmit}
                    >{this.renderForm()}</Formik>
                </Col>
            </>
        );
    }

    public renderForm = () => {
        return RegionsForm({
            editing: true,
            controls: (bag: FormikProps<IRegions>) => <ControlButtonSave />
        });
    };

    public handleSubmit = (values: any, actions: FormikHelpers<any>) => {
        actions.setSubmitting(true);
        const { regions } = this.injected.store;
        const { handleClose } = this.props;
        actions.setSubmitting(false);
        return regions
            .create(values)
            .then(() => {
                actions.resetForm();
                handleClose(values);
            })
            .catch(error => actions.setErrors(error.response.data));
    };
}

export default RegionsNew;
